import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaFileExcel, FaFilePdf, FaTimes } from "react-icons/fa";
import { format, subDays } from "date-fns";
import "./OBDReport.css";

const OBDReport = () => {
  const [searchInput, setSearchInput] = useState("");
  const [selectedVehicles, setSelectedVehicles] = useState([
    "KA02AH7852 (VEHICLE)",
    "KA 01 B 7947 (VEHICLE)",
  ]);
  const [dateRange, setDateRange] = useState("Last Day");
  const [startDate, setStartDate] = useState(
    format(subDays(new Date(), 1), "yyyy-MM-dd")
  );
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"));

  const removeVehicle = (vehicle) => {
    setSelectedVehicles(selectedVehicles.filter((v) => v !== vehicle));
  };

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setDateRange(value);

    const today = new Date();
    switch (value) {
      case "Last Day":
        setStartDate(format(subDays(today, 1), "yyyy-MM-dd"));
        setEndDate(format(today, "yyyy-MM-dd"));
        break;
      case "Last 7 Days":
        setStartDate(format(subDays(today, 7), "yyyy-MM-dd"));
        setEndDate(format(today, "yyyy-MM-dd"));
        break;
      case "Custom":
        // Keep current dates for custom selection
        break;
      default:
        break;
    }
  };

  const handleReset = () => {
    setSearchInput("");
    setSelectedVehicles(["KA02AH7852 (VEHICLE)", "KA 01 B 7947 (VEHICLE)"]);
    setDateRange("Last Day");
    setStartDate(format(subDays(new Date(), 1), "yyyy-MM-dd"));
    setEndDate(format(new Date(), "yyyy-MM-dd"));
  };

  return (
    <div className="obd-report-container">
      <h1 className="report-title">OBD II Report</h1>
      <hr className="obd-report-line" width="100%" />
      <div className="controls-container">
        <div className="search-container-obd">
          <FaSearch className="search-icon-obd" />
          <input
            type="text"
            placeholder="Search Vehicles or Groups"
            className="search-input-obd"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </div>

        <div className="date-range-container">
          <label className="control-label">Date Range</label>
          <select
            value={dateRange}
            onChange={handleDateRangeChange}
            className="date-range-select"
          >
            <option>Last Day</option>
            <option>Last 7 Days</option>
            <option>Custom</option>
          </select>
        </div>

        <div className="date-input-container">
          <label className="control-label">Start Date:</label>
          <input
            type="date"
            className="date-input"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            disabled={dateRange !== "Custom"}
          />
        </div>

        <div className="date-input-container">
          <label className="control-label">End Date:</label>
          <input
            type="date"
            className="date-input"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            disabled={dateRange !== "Custom"}
          />
        </div>

        <button className="generate-report-btn">GENERATE REPORT</button>

        <button className="action-btn-obd reset-btn" onClick={handleReset}>
          RESET
        </button>
        <Link to="/Report">
          <button className="action-btn-obd back-btn">
            BACK TO ALL REPORTS
          </button>
        </Link>
        <FaFileExcel className="excel-icon file-icon" title="Export to Excel" />
        <FaFilePdf className="pdf-icon file-icon" title="Export to PDF" />
      </div>

      <div className="selected-vehicles-container">
        {selectedVehicles.map((vehicle, idx) => (
          <span key={idx} className="vehicle-tag">
            {vehicle}
            <FaTimes
              className="remove-icon"
              onClick={() => removeVehicle(vehicle)}
              title="Remove vehicle"
            />
          </span>
        ))}
      </div>

      <div className="table-container-obd">
        <table className="report-table-obd">
          <thead className="table-header">
            <tr>
              <th className="table-heading">AOI Name &#8593;</th>
              <th className="table-heading">AOI IN TIME</th>
              <th className="table-heading">AOI OUT TIME</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="3" className="no-data-cell">
                No data to display
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OBDReport;
 

